import React,{Component} from 'react'
export default class Loader extends Component{
    render(){
    return(
        <svg viewBox="25 25 50 50">
   <circle cx="50" cy="50" r="20" fill="none"/>
</svg>
    )
}
}